const state = {
  location: 0,
  menu: {
    1: 0
  }
}

const getters = {
  getScrollLocation: state => state.location,
  getScrollMenu: (state) => (hostId) => {
    return state.menu[parseInt(hostId)]
  }
}

const mutations = {
  setScrollLocation (state, scroll) {
    state.location = scroll
  },

  setScrollMenu (state, payload) {
    state.menu[parseInt(payload.hostId)] = parseInt(payload.scroll)
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/scrollposition.js